
import React from "react";

export const LoadingState = () => {
  return (
    <div className="flex-1 p-6 flex items-center justify-center">
      <p className="text-github-text font-inter">Loading prompt...</p>
    </div>
  );
};
